<template>
  <div class="bind-card-fail-tip">
    <div style="line-height: 18px">
      <el-icon color="#faad14" size="14"><InfoFilled /></el-icon>
    </div>
    <div style="margin-left: 6px">
      <div>{{ $t('cards.home.card_bind_fail_tip') }}</div>
      <div style="margin-top: 3px" v-if="order?.subLabel">
        {{
          $t('cards.home.card_bind_fail_with_reasons', [
            $t(`cards.home.card_bind_fail_reason_${order.subLabel}`, [(fiatJSON[order.currency] || '$') + ' 1']),
          ])
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InfoFilled } from '@element-plus/icons-vue';
import { fiatJSON } from '@/common/js/const';
const props = defineProps<{
  order: any;
  showError?: boolean;
}>();
</script>

<style lang="less" scoped>
.bind-card-fail-tip {
  border-radius: 8px;
  background: rgba(250, 173, 20, 0.1);
  display: flex;
  color: #faad14;
  padding: 8px;
  font-size: 12px;
  line-height: 15.6px;
}
</style>
